<script>
export default {
  props: {
    projectKey: {
      type: String,
      default: "",
    },
  },
  render(h) {
    return h(
      "a",
      {
        attrs: {
          href: "https://atominc.atlassian.net/browse/" + this.projectKey,
          target: "_blank",
        },
      },
      this.projectKey
    );
  },
};
</script>